import WidgetHeadline from './WidgetHeadline'
export default WidgetHeadline
